import {
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import Body from "../../components/body/BodyPage";
import MainLinks from "../../components/navlinks/MainLinks";
import Blfgroups from "../../components/topviews/phonesanddevices/BlfGroups";
import IPhonesAndDevices from "../../components/topviews/phonesanddevices/IpPhonesandDevices";
import PagingGroups from "../../components/topviews/phonesanddevices/PagingGroups";
import Map from '../../../src/components/topviews/phonesanddevices/Map';
import EditWarning from "../../components/header/EditWarning";
import { useAdminContext } from "../../components/adminstore/Admin-Context";


function PSLandingPage(props) {
  const location = useLocation();
  const navigate = useNavigate();
  console.log("[PSLandingPage]location state:::::" + JSON.stringify(location.state) + "  Props:::::::" + JSON.stringify(props));
  let activeTab = location.state ? location.state.tab ? location.state.tab : "tab2" : "tab2";
  const [basicActive, setBasicActive] = useState(activeTab);
  const [showAddDevice, setShowAddDevice] = useState(false);
  const { showAddDevice: showAddDeviceState = false } = location.state || false;
  const inputRef = useRef(null);
  const { isEdited, setEdited } = useAdminContext();
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const handleBasicClick = (value) => {
    if(value == "tab1"){
      setBasicActive(null);
      setTimeout(()=>{setBasicActive(value)},0);
    }
    if (value === basicActive) {
      return;
    }  
     if (isEdited) {
      setTargetView(value);
      setShowWarning(true);
      return;
    }

    setBasicActive(value);
  };

  const handleOk = () => {
    setEdited(false);
    setBasicActive(targetView);
    setShowWarning(false);
  };

  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

    useEffect(() => {
      setShowAddDevice(showAddDeviceState);
    }, [showAddDeviceState]);
  
  return (
    <React.Fragment>
      <>
        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={10}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header px-0">
                    <h5 className="fw-600">{t("IPPhonesDevice")}</h5>
                  </div>
                  <div className="card-body px-0">
                    <MDBTabs className="mb-3">
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab2")}
                          active={basicActive === "tab2"}
                          >
                          {t("IPPhonesDevice")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab1")}
                          active={basicActive === "tab1"}
                        >
                        {t("OnlineDeviceMap")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab4")}
                          active={basicActive === "tab4"}
                        >
                          {t("BLFGroups")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab3")}
                          active={basicActive === "tab3"}
                        >
                          {t("PagingGroups")}
                        </MDBTabsLink>
                      </MDBTabsItem>

                    </MDBTabs>

                    <MDBTabsContent>
                      {basicActive === "tab1" && <MDBTabsPane open={basicActive === "tab1"} ><Map/></MDBTabsPane>}
                      {basicActive === "tab2" && <MDBTabsPane open={basicActive === "tab2"} ><IPhonesAndDevices showAddDevicePopup={showAddDevice} active={basicActive}/></MDBTabsPane>}
                      {basicActive === "tab3" && <MDBTabsPane open={basicActive === "tab3"} ><PagingGroups active={basicActive}/></MDBTabsPane>}
                      {basicActive === "tab4" && <MDBTabsPane open={basicActive === "tab4"} ><Blfgroups active={basicActive}/></MDBTabsPane>}
                    </MDBTabsContent>


                  </div>
                </div>
              </section>
            </>
          }
        />
        {showWarning && (
          <EditWarning
            warningToggle={warningToggle}
            setShowWarning={setShowWarning}
            onOk={handleOk}
          />
        )}
        {/* <Footer /> */}
      </>
    </React.Fragment>
  );
}

export default PSLandingPage;
